// extracted by mini-css-extract-plugin
module.exports = {"endScreenContainer":"end-screen_endScreenContainer_GIx","tooltipActive":"end-screen_tooltipActive_Tf0"};